import { __assign } from '../node_modules/tslib/tslib.es6.mjs.js';
import React from 'react';
import { Icon } from '@chakra-ui/react';

var FilledArrowRight = function (props) { return (React.createElement(Icon, __assign({ width: "20px", height: "20px", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M13.6095 10.9888C14.1302 10.4422 14.1302 9.55442 13.6095 9.00777L8.27828 3.41011C7.89509 3.00777 7.32448 2.8897 6.82468 3.10836C6.32487 3.32702 6 3.8343 6 4.40282L6 15.5981C6 16.1623 6.32487 16.674 6.82468 16.8926C7.32448 17.1113 7.89509 16.9888 8.27828 16.5909L13.6095 10.9932L13.6095 10.9888Z", fill: "currentColor" }))); };

export { FilledArrowRight as default };
//# sourceMappingURL=FilledArrowRight.js.map
